import React, { useEffect, useState } from "react";
import {
  ConnectComponentsProvider,
  ConnectAccountOnboarding,
} from "@stripe/react-connect-js";
import { Server2 } from "../../../redux/actions/auth/auth.actions";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import axios from "axios";

const StripeConnectOnboarding = ({ userId, onConfirm }) => {
  const stripeLoad = process.env.REACT_APP_STRIPE_PROMISE
  const [connectInstance, setConnectInstance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const initializeStripeConnect = async () => {
      try {
        setLoading(true);
        setError(null);

        const instance = await loadConnectAndInitialize({
          publishableKey: stripeLoad,

          fetchClientSecret: async () => {
            console.log('Stripe requested a client secret');

            var config = {
              method: "POST",
              url: Server2 + "/stripe/connect",
              data: {userId},
              headers: { "Content-Type": "application/json" },
            };

            return await axios(config).then((response) => {
              if (response.data) return response.data;
            })
            .catch((error) => {
              console.log("I am Error", error);
            });

          },
        });

        if (!mounted) return;

        setConnectInstance(instance);
      } catch (err) {
        console.error(err);
        setError(
          err?.message ||
            "Unable to initialize Stripe Connect"
        );
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    initializeStripeConnect();

    return () => {
      mounted = false;
    };
  }, [stripeLoad]);

  if (loading) {
    return (
      <div className="text-center py-5">
        Loading Stripe onboarding...
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          color: "red",
          padding: "20px",
        }}
      >
        {error}
      </div>
    );
  }

  if (!connectInstance) {
    return (
      <div>
        Unable to load Stripe Connect.
      </div>
    );
  }

  return (
    <ConnectComponentsProvider connectInstance={connectInstance}>
      <ConnectAccountOnboarding
        collectionOptions={{
          fields: "eventually_due",
          futureRequirements: "include",
        }}
        onExit={onConfirm}
      />
    </ConnectComponentsProvider>
  );
};

export default StripeConnectOnboarding;